var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-freelancer-client-info"},[_c('avatar-upload',{staticClass:"avatar",attrs:{"file-url":_vm.avatarUrl},on:{"changed":_vm.avatarChanged}}),_c('s-p-freelancer-client-info-form',{attrs:{"value":_vm.spFreelancerRegistrationClientInfo},on:{"changed":_vm.formChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }